'use strict';

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var biEvents = require('./bi/events');

var _require = require('../../utils/utils'),
    pick = _require.pick,
    get = _require.get,
    cssStringToObject = _require.cssStringToObject;

var _require2 = require('../../utils/domUtils'),
    setAttributes = _require2.setAttributes,
    setStyle = _require2.setStyle,
    setCssVars = _require2.setCssVars,
    getScreenHeight = _require2.getScreenHeight,
    getDocumentScrollPosition = _require2.getDocumentScrollPosition;

var _require3 = require('../../utils/imageUtils'),
    getImageComputedProperties = _require3.getImageComputedProperties,
    getImageSrc = _require3.getImageSrc,
    getMaskBBox = _require3.getMaskBBox; // ImageX component uses cssVars for scrollEffect calculation.
// Values for some of these vars are set here


var COMP_HEIGHT_CSS_VAR = '--compH';
var COMP_TOP_CSS_VAR = '--top';
var SCROLL_CSS_VAR = '--scroll';

function getDefaultStyles(style) {
  var _style = style,
      width = _style.width,
      height = _style.height,
      styleWithoutDimensions = _objectWithoutPropertiesLoose(_style, ["width", "height"]); // eslint-disable-line no-unused-vars


  var stylesWithValue = {};

  for (style in styleWithoutDimensions) {
    if (styleWithoutDimensions[style] !== '') {
      stylesWithValue[style] = styleWithoutDimensions[style];
    }
  }

  return stylesWithValue;
}

function getContainerStyle(style, opacity) {
  var styleWithoutDefaults = getDefaultStyles(style);

  if (typeof opacity === 'number') {
    styleWithoutDefaults.opacity = opacity;
  }

  return styleWithoutDefaults;
}

function getScrollEffectCssVars(measures) {
  var _ref;

  return _ref = {}, _ref[COMP_HEIGHT_CSS_VAR] = measures.height, _ref[COMP_TOP_CSS_VAR] = Math.ceil(measures.boundingRect.y) + measures.documentScroll, _ref[SCROLL_CSS_VAR] = measures.documentScroll, _ref;
}

function needScrollEffectCssVars(isZoomed, defaultScrollEffect, sourceSets) {
  if (sourceSets === void 0) {
    sourceSets = [];
  }

  var hasParallax = defaultScrollEffect === 'parallax' || sourceSets.some(function (sourceSet) {
    return sourceSet.scrollEffect === 'parallax';
  });
  return !isZoomed && hasParallax;
}

function hasScrollEffect(isZoomed, defaultScrollEffect, sourceSets) {
  if (sourceSets === void 0) {
    sourceSets = [];
  }

  var hasEffect = function hasEffect(name) {
    return name && name !== 'none';
  };

  return !isZoomed && (hasEffect(defaultScrollEffect) || sourceSets.some(function (sourceSet) {
    return hasEffect(sourceSet.scrollEffect);
  }));
}

function getImageHeight(measures, originalHeight, scrollEffect, parallaxSpeed) {
  if (parallaxSpeed === void 0) {
    parallaxSpeed = 1.5;
  }

  var heightForScrollEffect = {
    parallax: measures.height * parallaxSpeed,
    fixed: measures.screenHeight
  };
  return measures.isZoomed ? originalHeight : heightForScrollEffect[scrollEffect] || measures.height;
}

function getImageStyle(imageComputedProperties, isZoomed, scrollEffect, sourceSets) {
  var imageCss = get(imageComputedProperties, ['css', 'img']);

  if (hasScrollEffect(isZoomed, scrollEffect, sourceSets)) {
    // for scroll effect do not set height, it would be set by css selector from outside
    return Object.assign({
      width: '100%',
      height: undefined
    }, pick(imageCss, ['objectFit']));
  }

  return imageCss;
}

function sendBiEvent(biService, envConsts, imageInfo, imageToLoad, imageComputedProperties) {
  // should send Bi Event if we are on viewer, url includes upscale value lg_
  var upscaleMatcher = /,lg_(\d)/;
  var upscaleResult = imageComputedProperties.uri.match(upscaleMatcher);
  var shouldSendBiEvent = envConsts.isViewerMode && imageComputedProperties.uri !== imageToLoad.currentSrc && upscaleResult;

  if (shouldSendBiEvent) {
    biService.reportBI(biEvents.IMAGE_UPSCALING, {
      originalWidth: imageInfo.imageData.width,
      originalHeight: imageInfo.imageData.height,
      targetWidth: Math.round(imageInfo.containerWidth),
      targetHeight: Math.round(imageInfo.containerHeight),
      upscaleMethod: upscaleResult[1] === '1' ? 'classic' : 'super',
      devicePixelRatio: Math.floor(envConsts.devicePixelRatio * 100),
      url: imageToLoad.src
    });
  }
}

function measure(id, measures, domNodes, containerId, isSvgImage, isSvgMask) {
  var imageNode = domNodes.image;

  if (!imageNode) {
    return;
  }

  var imgSrc = getImageSrc(imageNode, isSvgImage);
  var hasBgScrollEffect = domNodes[id].getAttribute('data-has-bg-scroll-effect') === 'true';
  measures.width = hasBgScrollEffect ? domNodes[containerId].offsetWidth : domNodes[id].offsetWidth;
  measures.height = domNodes[id].offsetHeight;
  measures.containerTop = domNodes[containerId].offsetTop;
  measures.isZoomed = domNodes[id].getAttribute('data-image-zoomed');
  measures.isSvgImage = isSvgImage;
  measures.imgSrc = imgSrc;
  measures.containerId = containerId;
  measures.renderedStyles = domNodes[id].getAttribute('data-style');
  measures.screenHeight = getScreenHeight();
  measures.boundingRect = domNodes[id].getBoundingClientRect();
  measures.documentScroll = getDocumentScrollPosition();

  if (isSvgMask) {
    measures.bBox = getMaskBBox(domNodes.maskSvg);
  }
}

function computeSourceSets(measures, imageInfo, envConsts, pictureNode) {
  var sourceSets = imageInfo.sourceSets;

  if (!sourceSets || !sourceSets.length) {
    return;
  }

  var imageInfoClone = JSON.parse(JSON.stringify(imageInfo));
  var imageOriginalHeight = imageInfoClone.imageData.height;
  var parallaxSpeed = imageInfoClone.parallaxSpeed;
  sourceSets.forEach(function (sourceSet) {
    var sourceNode = pictureNode.querySelector("source[media='" + sourceSet.mediaQuery + "']");
    imageInfoClone.imageData.crop = sourceSet.crop;
    imageInfoClone.imageData.displayMode = sourceSet.displayMode;
    imageInfoClone.imageData.focalPoint = sourceSet.focalPoint;
    imageInfoClone.containerHeight = getImageHeight(measures, imageOriginalHeight, sourceSet.scrollEffect, parallaxSpeed);
    var imageComputedProperties = getImageComputedProperties(imageInfoClone, envConsts, 'img');
    setAttributes(sourceNode, {
      'data-srcset': get(imageComputedProperties, 'uri')
    });
  });
}

function patch(id, measures, domNodes, imageInfo, services, envConsts, loadImage) {
  var style = cssStringToObject(measures.renderedStyles);
  var imageData = imageInfo.imageData,
      parallaxSpeed = imageInfo.parallaxSpeed;
  var extendedImageInfo = Object.assign({}, imageInfo, {
    containerWidth: measures.isZoomed ? imageData.width : measures.width,
    containerHeight: getImageHeight(measures, imageData.height, imageData.scrollEffect, parallaxSpeed),
    displayMode: imageData.displayMode
  });
  var needCssVars = needScrollEffectCssVars(measures.isZoomed, imageData.scrollEffect, imageInfo.sourceSets);
  var imageComputedProperties;

  if (measures.isSvgImage) {
    imageComputedProperties = getImageComputedProperties(extendedImageInfo, envConsts, 'svg');
    setAttributes(domNodes.svg, measures.isZoomed ? imageComputedProperties.attr.container : {});
  } else {
    imageComputedProperties = getImageComputedProperties(extendedImageInfo, envConsts, 'img');
    var imageStyle = getImageStyle(imageComputedProperties, measures.isZoomed, imageData.scrollEffect, imageInfo.sourceSets);
    setStyle(domNodes.image, imageStyle);

    if (needCssVars) {
      // wixui.ImageX implements scroll effects by css variables. provide their values here
      setCssVars(domNodes[id], getScrollEffectCssVars(measures));
    }
  }

  if (measures.bBox && domNodes.maskSvg) {
    setAttributes(domNodes.maskSvg, {
      viewBox: measures.bBox
    });
  }

  var containerStyle = getContainerStyle(style, imageData.opacity);
  setStyle(domNodes[id], containerStyle);
  var src = get(imageComputedProperties, 'uri'); //this was always like this (using _.get) and it looks like videoThumb images for wixapps explodes here since they dont have a uri -> no imageTransformProps

  var currentSrc = measures.imgSrc;
  setAttributes(domNodes[id], {
    'data-src': src
  }); //clear initial indication that the image src came from ssr render

  setAttributes(domNodes[id], {
    'data-has-ssr-src': ''
  });

  if (domNodes.picture) {
    computeSourceSets(measures, extendedImageInfo, envConsts, domNodes.picture);
  }

  if (loadImage) {
    sendBiEvent(services.biService, envConsts, extendedImageInfo, {
      src: src,
      currentSrc: currentSrc
    }, imageComputedProperties);
    services.imageLoader.loadImage(domNodes[id], {
      screenHeight: measures.screenHeight,
      boundingRect: measures.boundingRect,
      withScrollEffectVars: needCssVars
    });
  }
}

module.exports = {
  measure: measure,
  patch: patch
};
//# sourceMappingURL=imageLayout.js.map